import { __decorate, __metadata } from "tslib";
// NPM
import { Guid } from "guid-typescript";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { v4 as uuidv4 } from "uuid";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "@/router/layouts/main.vue";
import { dateHelpers } from "@/utilities/dateHelper";
import { EngagementStageModel } from "@/store/models/engagements/engagementStage";
import { EngagementActivityModel } from "@/store/models/engagements/engagementActivity";
import BaseMixer from "../BaseMixer";
import PageHeader from "@/components/page-header.vue";
import { toaster } from "../../../utilities/toaster";
import EngagementsModule from "../../../store/modules/engagements.module";
import StageActivity from "./components/StageActivity.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
setInteractionMode("passive");
let Engagement = /** @class */ (() => {
    var _a;
    let Engagement = class Engagement extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Engagement";
            this.items = [
                {
                    text: "Home",
                    href: "#",
                },
                {
                    text: "Engagements",
                    href: "#",
                },
                {
                    text: "",
                    active: false,
                },
            ];
            this.pageIsLoading = true;
            this.stageSwitcherOn = true;
            this.activeStage = Guid.createEmpty();
            this.showNewEngagementModal = false;
            this.selectedStageId = null;
            this.showDeleteStageModal = false;
            this.selectedStageDisplayOrder = null;
            this.isEditEngagement = false;
            this.tenantEngagement = {
                id: uuidv4(),
                name: "",
                projectTypeId: null,
                prospectName: "",
                projectType: null,
                type: "",
                createdOn: null,
                createdOnAsString: "",
                createdOnAsInputString: "",
            };
            this.showTenantEngagementStage = false;
            this.tenantEngagementStage = new EngagementStageModel();
            this.stageModalTitle = "";
            this.showNewTenantEngagementActivityModal = false;
            this.newTenantEngagementStageActivity = new EngagementActivityModel();
        }
        // EVENT WIRINGS - STAGE
        openNewEngagementModal() {
            this.isEditEngagement = true;
            this.tenantEngagement.name = this.engagement.name;
            this.tenantEngagement.prospectName = this.engagement.prospectName;
            if (this.engagement.projectTypeId == null) {
                this.tenantEngagement.projectTypeId = "00000000-0000-0000-0000-000000000000";
            }
            else {
                this.tenantEngagement.projectTypeId = this.engagement.projectTypeId;
            }
            this.showNewEngagementModal = true;
        }
        closeNewEngagementModal() {
            this.showNewEngagementModal = false;
        }
        openAddStageModal() {
            this.tenantEngagementStage = new EngagementStageModel();
            this.tenantEngagementStage.displayOrder = 0;
            this.showTenantEngagementStage = true;
            this.stageModalTitle = "New Stage";
        }
        openEditStageModal() {
            this.tenantEngagementStage = new EngagementStageModel();
            this.tenantEngagementStage = {
                stageId: this.stageComponentData.stageId,
                stageName: this.stageComponentData.stageName,
                isTenantVisible: this.stageComponentData.isTenantVisible,
                description: this.stageComponentData.description,
                activities: this.stageComponentData.activities,
                displayOrder: this.stageComponentData.displayOrder,
            };
            this.showTenantEngagementStage = true;
            this.stageModalTitle = "Edit Stage";
        }
        closeStageModal() {
            this.showTenantEngagementStage = false;
        }
        openAddActivityModal() {
            this.newTenantEngagementStageActivity = new EngagementActivityModel();
            this.showNewTenantEngagementActivityModal = true;
        }
        closeAddActivityModal() {
            this.showNewTenantEngagementActivityModal = false;
        }
        cancelEngagementEdit() {
            this.isEditEngagement = false;
            this.tenantEngagement.name = this.engagement.name;
            this.tenantEngagement.prospectName = this.engagement.prospectName;
            this.tenantEngagement.createdOn = new Date(this.engagement.createdOnAsString);
            this.tenantEngagement.createdOnAsString = this.engagement.createdOnAsString;
            if (this.engagement.projectTypeId == null) {
                this.tenantEngagement.projectTypeId = "00000000-0000-0000-0000-000000000000";
            }
            else {
                this.tenantEngagement.projectTypeId = this.engagement.projectTypeId;
            }
        }
        changeEditEngagement() { }
        // CRUD
        saveNewTenantEngagementStage() {
            this.validate("tenantEngagementStageObserver").then((response) => {
                if (response) {
                    EngagementsModule.SaveTenantEngagementStage([this.engagementId, this.tenantEngagementStage]).then((response) => {
                        this.closeStageModal();
                        // If there is one and only one stage, just select that.
                        if (this.engagement.stages.length == 1) {
                            this.currentActiveStage = this.engagement.stages[0].stageId;
                        }
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        removeStage(stageId) {
            this.selectedStageId = stageId;
            this.showDeleteStageModal = true;
        }
        closeModal(modalName) {
            var that = this;
            that.$root.$emit("bv::hide::modal", modalName);
        }
        deleteTenantEnagagementStage() {
            var that = this;
            EngagementsModule.DeleteTenantEnagagementStage(that.selectedStageId).then((response) => {
                this.showDeleteStageModal = false;
                if (this.engagement.stages.length > 0) {
                    this.currentActiveStage = this.engagement.stages[0].stageId;
                }
                toaster.ShowApiSuccess(response);
            });
        }
        saveNewTenantEngagementActivity() {
            this.validate("newTenantEngagementStageActivtyObserver").then((response) => {
                if (response) {
                    EngagementsModule.SaveTenantEngagementActivity([this.engagementId, this.activeStage, this.newTenantEngagementStageActivity]).then((response) => {
                        this.closeAddActivityModal();
                        toaster.ShowApiSuccess(response);
                    });
                }
            });
        }
        saveEngagement() {
            this.validate("newEngagementObserver").then((response) => {
                if (response) {
                    this.tenantEngagement.id = this.engagement.id;
                    this.tenantEngagement.createdOnAsInputString = dateHelpers.convert(this.tenantEngagement.createdOn);
                    EngagementsModule.UpdateEngagement(this.tenantEngagement).then((response) => {
                        if (response) {
                            this.showNewEngagementModal = false;
                            this.isEditEngagement = false;
                            // this.getEngagement();
                            toaster.ShowApiSuccess(response);
                        }
                    });
                }
            });
        }
        // COMPUTED
        get engagement() {
            return EngagementsModule.model;
        }
        get currentActiveStage() {
            return this.activeStage;
        }
        set currentActiveStage(value) {
            this.activeStage = value;
        }
        get stageComponentData() {
            const that = this;
            return this.engagement.stages.find(function (stage) {
                return that.activeStage === stage.stageId;
            });
        }
        get projectTypes() {
            return EngagementsModule.projectTypes;
        }
        //LIFECYCLE
        created() {
            this.engagementId = Guid.parse(this.$route.params.engagementId);
            EngagementsModule.GetEngagement(this.engagementId).then((response) => {
                if (response) {
                    if (this.engagement.stages.length > 0) {
                        this.currentActiveStage = this.engagement.stages[0].stageId;
                    }
                    this.items[2].text = this.engagement.name;
                    this.tenantEngagement.name = this.engagement.name;
                    this.tenantEngagement.prospectName = this.engagement.prospectName;
                    this.tenantEngagement.createdOn = new Date(this.engagement.createdOnAsString);
                    this.tenantEngagement.createdOnAsString = this.engagement.createdOnAsString;
                    if (this.engagement.projectTypeId == null) {
                        this.tenantEngagement.projectTypeId = "00000000-0000-0000-0000-000000000000";
                    }
                    else {
                        this.tenantEngagement.projectTypeId = this.engagement.projectTypeId;
                    }
                    this.pageIsLoading = false;
                }
            });
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Guid !== "undefined" && Guid) === "function" ? _a : Object)
    ], Engagement.prototype, "engagementId", void 0);
    Engagement = __decorate([
        Component({
            name: "Engagement",
            components: {
                Layout,
                PageHeader,
                StageActivity,
                DeleteComponent,
            },
        })
    ], Engagement);
    return Engagement;
})();
export default Engagement;
